<template>
  <el-container>
    <el-main>
      <page-sentry
        @allowed="handleAllowed"
        @disallowed="handleDisallowed"
      >
        <template slot="allowed">
          <page-upload
            :accessKey="accessKey"
            :uploadInfo="uploadInfo"
          />
        </template>
        <template slot="disallowed">
          <page-forbidden />
        </template>
      </page-sentry>
    </el-main>
  </el-container>
</template>

<script>
// Element UI
import '@/utils/elementUiImporter';
// Vue components
import PageSentry from '@/pages/Sentry';
import PageUpload from '@/pages/Upload';
import PageForbidden from '@/pages/Forbidden';

export default {
  name: 'App',
  components: {
    PageSentry,
    PageUpload,
    PageForbidden,
  },
  data() {
    return {
      uploadInfo: null,
      accessKey: null,
      error: null,
    };
  },
  methods: {
    handleAllowed(result) {
      this.accessKey = result.uuid;
      this.uploadInfo = result;
    },
    handleDisallowed(error) {
      this.error = error;
    },
  },
};
</script>

<style lang="scss">
@import './assets/styles/style';

</style>



// WEBPACK FOOTER //
// src/App.vue